module.exports = __webpack_public_path__ + "static/img/wp2.e6dde35.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/rotate/wp2.png
// module id = KNro
// module chunks = 1